import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useSearchParams } from 'react-router';

import { FullPage } from '@/components/page';
import { Link, Text } from '@/components/typography';
import { setPreferredSignInMethod } from '@/helper/user-preferences';
import { ROUTES } from '@/router';

import PasswordSignInForm from '../PasswordSignInForm';
import SignInPanel from '../SignInPanel';

const SignInPassword = () => {
  const [searchParams] = useSearchParams();
  const redirect = searchParams.get('redirect');

  return (
    <FullPage title={t`Sign In`}>
      <SignInPanel
        title={t`Sign In to Channel99`}
        footer={
          <>
            <Text variant="caption1" color="grey">
              <Trans>
                Forgot your password?{' '}
                <Link
                  variant="caption1"
                  color="aqua"
                  to={`${ROUTES.signInPasswordForgot.path}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`}
                >{t`Reset your password`}</Link>
              </Trans>
            </Text>
            <Text variant="caption1" color="grey">
              <Trans>
                Prefer to not use a password?{' '}
                <Link
                  variant="caption1"
                  color="aqua"
                  to={`${ROUTES.signIn.path}${searchParams.size > 0 ? `?${searchParams.toString()}` : ''}`}
                >{t`Sign in another way`}</Link>
              </Trans>
            </Text>
          </>
        }
        showGap
      >
        <PasswordSignInForm
          redirectUrl={redirect ?? undefined}
          onSuccess={() => setPreferredSignInMethod('email')}
        />
      </SignInPanel>
    </FullPage>
  );
};

export default SignInPassword;
